import React, { useState } from 'react';
import LabelCustomizer from './LabelCustomizer';
import { useStateValue } from '../context/StateProvider';

import './CustomizerPage.scss';
import Button from './LabelCustomizer/Button';
import { LeftCircleOutlined } from '@ant-design/icons';

import { actionTypes } from '../context/reducer';

import { v4 as uuidv4 } from 'uuid';

const CustomizerPage = ({ productID, useTemplate, setUseTemplate, setCustomizing, setCurrentProduct }) => {
  const [{ products }, dispatch] = useStateValue();

  const getProductNameByID = (productList, id) => {
    const productFound = productList.find((item) => item.id === id);
    return productFound.name;
  };



  const handleAddCart = (labelPNG) => {
    dispatch({
      type: actionTypes.ADD_TO_CART,
      product: {
        productId: productID,
        quantity: 1,
        labelId: uuidv4(),
        labelPNG
      }
    });
  };
  // const wineUsed = productID ? getProductNameByID(products, productID) : "";
  

  return (
    <main className="customizerpage">
      <div className="bottle-container">
        
        {/* <img
          className="product-image"
          src={`/WineBottles/${wineUsed}.png`}
          alt=""
        /> */}
        <div className="label-container">
          <LabelCustomizer
            setCustomizing={setCustomizing}
            handleAddCart={handleAddCart}
            useTemplate={useTemplate}
            setUseTemplate={setUseTemplate}
            products={products}
            setCurrentProduct={setCurrentProduct}
            productID={productID}
          />
        </div>
      </div>
        
    </main>
  );
};

export default CustomizerPage;
